const OfertasProdutoController = ControllerBase.extend({
    name: "OfertasProdutoController",
    framework: "knockout",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.produto.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function () {

        this.filtros = {
            CodigoProduto: this.produto.get("IdentificadorOrcamento") ? this.produto.get("CodigoProduto") : this.produto.get("Codigo"), // FNX-998, FNX-999, FNX-1001
            NumeroPagina: 1,
            TamanhoPagina: 10
        };

        return {
            url: "/Produto/_Ofertas",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento === undefined ? null : this.orcamento.get("IdentificadorOrcamento"),
                filtros: this.filtros
            })
        };
    },

    antesBinding: function () {

        var referenciaProduto = this.produto.get("ReferenciaProduto")
            ? this.produto.get("ReferenciaProduto")
            : this.produto.get("Referencia")
            ? this.produto.get("Referencia")
            : this.produto.get("Codigo");

        this.appendToModel({ name: "produto", value: this.produto.get("DescricaoProduto") });
        this.appendToModel({ name: "referenciaProduto", value: referenciaProduto });
    },

    aposBinding: function () {

        var data = this.toJS(this.model);

        this.atualizarPaginador(data);
    },

    atualizarPaginador: function (data) {

        this.paginador = new Paginator({
            container: "#page-ofertas",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    paginar: function (e) {
        this.filtros.NumeroPagina = e.page;

        var self = this;

        global.ajax({
            url: "/Produto/ListarOfertasProduto",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento === undefined ? null : this.orcamento.get("IdentificadorOrcamento"),
                filtros: this.filtros
            }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.Entities(m());
                self.atualizarPaginador(data);


            }
        });
    },


})

window.OfertasProdutoController = OfertasProdutoController

export {
    OfertasProdutoController
}